/**
 * package: com.inq.flash.client.data
 * class: ChatAutomatonResponseMessage
 * @extends com.inq.flash.messagingframework.Message
 * @constructor
 */
com.inq.flash.client.data.ChatAutomatonResponseMessage = function (chat, eventName, data) {
	com.inq.flash.messagingframework.Message.call(this);
	this.setMessageType(com.inq.flash.client.data.MessageFields.TYPE_CHAT_AUTOMATON_RESPONSE);
	this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_ID, chat.getChatID());
	this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CONFIG_ENTRY_INC_ASSIGNMENT_ID, chat.getIncAssignmentId());
	this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CONFIG_ENTRY_SESSION_ID, chat.getSessionId());
	this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CONFIG_ENTRY_CUSTOMER_ID, chat.getCustomerID());
	this.addProperty(com.inq.flash.client.data.MessageFields.KEY_BUSINESS_UNIT_ID, chat.getBusinessUnitID());
	this.addProperty(com.inq.flash.client.data.MessageFields.KEY_SITE_ID, chat.getSiteID());
	this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_AUTOMATON_EVENT, eventName);
    if (com.inq.flash.client.control.FlashPeer.getCustGeoData()) {
        this.addProperty(com.inq.flash.client.data.MessageFields.KEY_COUNTRY_CODE, com.inq.flash.client.control.FlashPeer.getCustGeoData().country_code);
        this.addProperty(com.inq.flash.client.data.MessageFields.KEY_REGION_CODE, com.inq.flash.client.control.FlashPeer.getCustGeoData().region_code);
    }
	if (data) {
		if (data.type) this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_AUTOMATON_TYPE, data.type);
		if (data.id) this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_AUTOMATON_ID, data.id);
		if (data.state) this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_AUTOMATON_STATE, data.state);
		if (data.model) this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_AUTOMATON_DATA_MODEL, data.model);
		if (data.loggedQuestion) this.addProperty(com.inq.flash.client.data.MessageFields.KEY_DT_QUESTION, data.loggedQuestion);
		if (data.answerText) this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_AUTOMATON_DATA, data.answerText);
	}
};
$hxClasses['com.inq.flash.client.data.ChatAutomatonResponseMessage'] = com.inq.flash.client.data.ChatAutomatonResponseMessage;
/** @private @type {Array} */
com.inq.flash.client.data.ChatAutomatonResponseMessage.__name__ = ["com","inq","flash","client","data","ChatAutomatonResponseMessage"];
/** @private @type {Function} */
com.inq.flash.client.data.ChatAutomatonResponseMessage.__super__ = com.inq.flash.messagingframework.Message;
for(var k in com.inq.flash.messagingframework.Message.prototype ) com.inq.flash.client.data.ChatAutomatonResponseMessage.prototype[k] = com.inq.flash.messagingframework.Message.prototype[k];
/** @type {com.inq.flash.client.data.ChatAutomatonResponseMessage} */
com.inq.flash.client.data.ChatAutomatonResponseMessage.prototype.__class__ = com.inq.flash.client.data.ChatAutomatonResponseMessage;
